export default __webpack_public_path__ + "static/media/logorote.2182835f.png";